export const plasmicIFrameWheelEvent = "plasmicIFrameWheelEvent";
export const plasmicIFrameMouseDownEvent = "plasmicIFrameMouseDownEvent";
export const plasmicCanvasTransformEvent = "plasmicCanvasTransformEvent";
